export const SET_CURRENT_SELECTED_VISIT = 'SET_CURRENT_SELECTED_VISIT';
export const SET_CURRENT_VISITS_DETAILS = 'SET_CURRENT_VISITS_DETAILS';
export const SET_VISITS_FILTERS = 'SET_VISITS_FILTERS';
export const SET_VISITS_TOTAL_RECORDS = 'SET_VISITS_TOTAL_RECORDS';
export const SET_VISITS_GRID_SORT_CRITERIA = 'SET_VISITS_GRID_SORT_CRITERIA';
export const RESET_VISITS_FILTERS = 'RESET_VISITS_FILTERS';
export const FETCH_VISITS_RECORDS = 'FETCH_VISITS_RECORDS';
export const SET_VISITS_LIST_IS_LOADING = 'SET_VISITS_LIST_IS_LOADING';
export const SET_VISITS_LIST_IS_NOT_LOADING = 'SET_VISITS_LIST_IS_NOT_LOADING';
export const SET_VISITS_RECORDS = 'SET_VISITS_RECORDS';
export const CLEAN_VISITS_RECORDS = 'CLEAN_VISITS_RECORDS';
